import { Component, EventEmitter, Output } from '@angular/core';
import { DsButtonVariants, DsModalService } from '@levelaccess/design-system';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-remove-app-modal',
  templateUrl: './remove-app-modal.component.html',
  styleUrl: './remove-app-modal.component.scss',
  standalone: false,
})
export class RemoveAppModalComponent {
  @Output()
  public removeAppConfirmed: EventEmitter<void> = new EventEmitter<void>();

  public readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;

  constructor(
    private modalService: DsModalService,
    public modal: NgbActiveModal,
  ) {}

  public cancelled(): void {
    this.modalService.previousModal();
  }

  public removeApp(): void {
    this.removeAppConfirmed.emit();
    this.modalService.previousModal();
  }
}
